class Feature {
  static isEnabled(featureName) {
    switch (featureName) {
      default:
        return true
    }
  }

  static get isProduction() {
    return this._env === "production"
  }

  static get _env() {
    return process.env.RAILS_ENV
  }
}

export default Feature
